import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"
import Icon from "./Icon"
import Checkbox from "./Checkbox"
// import { isMobile } from "../../helpers";

export default function SortDropdown() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);
    const [optionName, setOptionName] = useState("");

    const handleSortChange = (event) => {
        // console.log(event.target)
        const inputField = event.target;
        const nextSibling = inputField.nextSibling;
        setSort(event.target.value);
        setOptionName(nextSibling.textContent);
        // toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    // console.log(activeSort, "activeSort");
    // console.log(optionName, "optionName");
    // console.log(sortOpen, "sortOpen");

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target) && toggleRef.current && !toggleRef.current.contains(event.target)) {
            if (sortOpen) {
                toggleSort();
            }
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sortOpen, setSortOpen]);

    return (
        <div class={`ns-dropdown-container accordian collection-filters__sort-by ${sortOpen ? "ns-sort-active":""}`}>
            <div class="justify-between">
                <button
                // button button--collapsible
                    className="ns-custom-sort-toggle-btn ns-font-1"
                    type="button"
                    aria-haspopup="true"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="sort-label"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    // onClick={()=>{
                    //     toggleSort();
                    //     setOpenedFacetId("ns-sort-menu");
                    // }}
                    onClick={toggleSort}
                    ref={toggleRef}
                >
                    {/* <span class="icon icon-new icon-sort ">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m7.296 4.227-.48-.48-.48.48L2.75 7.814l-.48.48.96.96.48-.48 2.427-2.428V19.309h1.358V6.346l2.428 2.428.48.48.96-.96-.48-.48-3.587-3.587zm10.367 15.546-.48.48-.48-.48-3.586-3.586-.48-.48.96-.96.48.48 2.427 2.427V4.691h1.358v12.963l2.428-2.427.48-.48.96.96-.48.48-3.587 3.586z" fill="currentColor"></path></svg>
                    </span> */}
                    <span
                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                        id="sort-label"
                    >
                        Sort By: 
                    </span>
                    <span className="body-2--medium lg:inline">
                        {sortOptions.find(option => option.id === activeSort)?.value?.name}
                    </span>
                    {/* <span class="icon icon-new icon-chevron-small ">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2.75"></path></svg>
                    </span> */}
                </button>
            </div>
            
            <div
                // className="absolute bg-white m-w-full z-1"
                id="ns-sort-dropdown"
                aria-hidden={!sortOpen}
                ref={dropdownRef}
                tabIndex="0"
                // accordion__content
                class="content"
                >
                    {/* <div class="ns-sidebar-header ns-d-none ns-align-items-baseline ns-relative">
                        <span class="ns-font-bold ns-font-5 ns-color-black">Sort</span>
                       <button type="button" class="filter-drawer__close" aria-label="Close" onClick={toggleSort}>
                            <span class="icon-button icon-button-close  icon-button--small ">
                                <span class="icon-button__icon">
                                    <span class="icon icon-new icon-close ">
                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.66 1.34 2 .68.68 2l.66.66 1.32-1.32zm18.68 21.32.66.66L23.32 22l-.66-.66-1.32 1.32zm1.32-20 .66-.66L22 .68l-.66.66 1.32 1.32zM1.34 21.34.68 22 2 23.32l.66-.66-1.32-1.32zm0-18.68 10 10 1.32-1.32-10-10-1.32 1.32zm11.32 10 10-10-1.32-1.32-10 10 1.32 1.32zm-1.32-1.32-10 10 1.32 1.32 10-10-1.32-1.32zm0 1.32 10 10 1.32-1.32-10-10-1.32 1.32z" fill="currentColor"></path>
                                        </svg>
                                    </span>
                                </span>
                            </span>
                        </button>
                    </div> */}
                    {/* bg-background-0 z-30 absolute mt-[20px] w-[200px] h-fit flex flex-col lg:w-[290px] lg:h-auto lg:pr-[0px] lg:right-0 lg:right-auto lg:mt-[2px] lg:top-[30px] lg:pt-[0px] */}
                <ul className="ns-sort-menu filter-group-display__list flex flex-col">
                    {sortOptions.map((option) => {
                        // console.log(option.id)
                        return (
                        
                        <li 
                            key={option?.id}
                            // pb-[20px] pl-[20px] pr-[20px] lg:pb-[16px] lg:border-b-0
                            class="ns-sort-option filter-group-display__list-item ns-font-1"
                        >
                            <label
                                class="radio ns-checkbox"
                            >
                                <input
                                    className="sm"
                                    type="radio"
                                    name={`ns-sort`}
                                    value={option?.id} 
                                    checked={(activeSort === option?.id)}
                                    onChange={(e) => {
                                        handleSortChange(e);
                                    }}
                                />
                                {/* <span className="ns-checkmark" /> */}
                                <span class="ns-font-1">
                                    {option.value.name}
                                </span>
                            </label>
                             {/* <label className={`ns-radio ns-color-black ns-d-flex ns-align-items-end ${className}`}>
                                <input type="radio" checked={(activeSort === option?.id)} onChange={(e) => {
                                        handleSortChange(e);
                                    }} value={option?.id} />
                                <span className="ns-checkmark" />
                                <span className="ns-mx-xs-1">{option.value.name}</span>
                            </label> */}
                            {/* <Checkbox
                                value={option?.id}
                                selected={(activeSort === option?.id)}
                                onChange={e => {
                                    e.preventDefault();
                                    handleSortChange(e);
                                }}
                            /> */}
                        </li>
                    )})}
                </ul>
                {/* {isMobile && <div class="filter-drawer__footer animation--filter-drawer-item ns-sort-dropdown-footer" style="--delay-offset-multiplier: 1;">
                    <div class="filter-drawer__footer-buttons">
                        <button type="button" class="filter-drawer__button-apply btn btn--primary" onClick={toggleSort}>
                        Done
                        </button>
                    </div>
                </div>} */}
            </div>
        </div>
    )
}